// These are distinct server-calculated measures; never derive receipts from
// invoice status or relabel an old gross-sale value as collected money.
export const FINANCIAL_MONEY_BASIS = 'invoice_and_collected';
export const FINANCIAL_REPORTS = [
  'sales_by_day', 'sales_by_type', 'sales_by_service',
  'sales_by_product', 'sales_by_staffmember',
];
export const FINANCIAL_DATE_NOTE = 'Invoiced sales follow invoice date; payments collected follow payment date, less successful refunds. Prepaid redemptions are not new payments. Item counts follow invoice date.';
export const RECEIPT_DATE_NOTE = 'Receipts follow payment date in the salon timezone, less successful refunds on their refund date. Deposits count when received; applying a deposit or prepaid credit is not a new receipt.';
export const GROUPED_RECEIPT_DATE_NOTE = `${RECEIPT_DATE_NOTE} A receipt may appear in more than one group. All matching rows counts each receipt once.`;
export const FINANCIAL_MEASURES = [
  {key:'invoiced_sales',label:'Invoiced sales'},
  {key:'payments_collected',label:'Payments collected'},
];

export const financialAmount = value => {
  if (value == null || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const formatFinancialAmount = (value, currency) => {
  const parsed = financialAmount(value);
  if (parsed == null) return '—';
  return `${parsed.toFixed(2)}${currency ? ` ${currency}` : ''}`;
};

export const selectFinancialReportContext = state => {
  const report = state?.report?.isListView;
  const exported = state?.report?.exportListRows;
  const data = report?.data;
  const rowCount = Array.isArray(data) ? data.length : data && typeof data === 'object' ? Object.keys(data).length : 0;
  return {
    financialTotals: report?.financial_totals,
    pageSubtotal: exported == null && Number(report?.total || 0) > rowCount,
  };
};
